
import { 
    DELETE_CASE,
    DELETE_CASE_SUCCESS,
    DELETE_CASE_FAIL, 
    DELETE_CASE_RESET,
} from "../actions/deleteCaseAction";

const initialState = {
    apiState: "",
    message: "",
    data: null,
    error: "",
}

const deleteCaseReducer = (state = initialState, action) => {
    switch (action.type) {
        case DELETE_CASE:
            return {
                ...state,
                apiState: "loading",
            };
        case DELETE_CASE_SUCCESS:
            return {
                ...state,
                apiState: "success",
                data: action.response.data,
                message: action.response.message ? action.response.message : "success",
            };
        case DELETE_CASE_FAIL:
            return {
                ...state,
                apiState: "error",
                error: action.response.errors,
                message: action.response.message ? action.response.message : "error",
            };
        case DELETE_CASE_RESET:
            return initialState;
        default: 
            return state;
    }
};

export default deleteCaseReducer;
